import Vue from "vue";
import VueI18n from "vue-i18n";

// read available json language files from ./i18n and register them as locales
function loadLocaleMessages() {
    const locales = require.context(
        "./i18n",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const dateTimeFormats = {
  'de': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    medium: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'en': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    medium: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  }
}


Vue.use(VueI18n)

let locale = 'de';

try {
    const locale_meta = document.head.querySelector('meta[name="locale"]').getAttribute('content');
    if(!locale_meta.length) {
        throw Error('locale content empty');
    }
    locale = locale_meta
} catch (e) {
    console.log('Could not load locale from meta tag')
}

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  dateTimeFormats: dateTimeFormats
})

export default i18n;
